module.exports = __webpack_public_path__ + "img/grid-localization.2457de17.png";